<template>
  <label class="error-label block mt-1 text-xs text-red-2 dark:text-dark-red">
    <slot></slot>
  </label>
</template>
<script setup>
import { defineProps } from 'vue'

defineProps({
  label: {
    type: String,
    default: '',
  },
})
</script>
